import { Pole } from './pole';

export class Rcbo1Pole extends Pole {}
